import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "payment-warning",
  "use": "payment-warning-usage",
  "viewBox": "0 0 45 45",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45 45\" id=\"payment-warning\"><path fill=\"#FE4B47\" d=\"M22.5 1C10.626 1 1 10.626 1 22.5S10.626 44 22.5 44 44 34.374 44 22.5 34.374 1 22.5 1m0-1C34.926 0 45 10.074 45 22.5S34.926 45 22.5 45 0 34.926 0 22.5 10.074 0 22.5 0m-.968 11a.5.5 0 0 0-.499.531l.938 15a.5.5 0 0 0 .499.469h.06a.5.5 0 0 0 .5-.469l.937-15a.5.5 0 0 0-.5-.531zm.968 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol